import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { E_CONTENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/e-contents/")({
  component: () => <DeptContentList cfg={E_CONTENTS} />,
});
